// extracted by mini-css-extract-plugin
module.exports = {"dj4vswd":"dj4vswd"};